import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { FontWeight, Text } from '@frontend/design-system';

const sanitizeValue = (value: string | undefined) => (value ? value : '-');

interface DetailTextProps {
  value?: string;
  required?: boolean;
  weight?: FontWeight;
}

export const DetailText = ({ value, required, weight = 'bold' }: DetailTextProps) => {
  const { t } = useTranslation('insuranceDetails');
  if (!required) {
    return (
      <Text
        title={sanitizeValue(value)}
        as='dd'
        weight={weight}
        size='medium'
        css={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {sanitizeValue(value)}
      </Text>
    );
  }
  const isEmpty = !value || value === '-';
  return (
    <Text
      as='dd'
      weight={weight}
      size='medium'
      css={{
        color: isEmpty ? theme.colors.critical50 : theme.colors.neutral90,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {isEmpty ? t('Required') : value}
    </Text>
  );
};
